import { makeStyles } from '@mui/styles';

const muiStyles = makeStyles(() => ({
    gridContainer: { marginLeft: '-20px' },
    tileColumnContainer: {
        display: 'flex',
        flexDirection: 'column',
        textAlign: 'left',
        padding: '0 10px',
        borderRight: '1px solid #CFCFCF',
        '&:last-child': { borderRight: 'none' }
    },
    divider: {
        marginBottom: '5px',
        color: '#CFCFCF',
        width: '80%',
        marginLeft: '10%'
    },
    tileContainer: { height: '70px' },
    tileText: {
        minWidth: 'max-content',
        textAlign: 'center',
        fontSize: '12px',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: '0.3px',
        color: '#757575',
        paddingLeft: '12px'
    },
    tileBalanceText: {
        fontSize: '20px',
        fontStyle: 'normal',
        lineHeight: 'normal',
        textAlign: 'center',
        color: '#000000',
        paddingLeft: '12px'
    }
}));

export default muiStyles;